/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_TitleInputs */

const en_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finish the Motion`)
};

const es_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termina el movimiento`)
};

const de_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beenden Sie die Bewegung`)
};

const zh_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把动作完成`)
};

const ar_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل الحركة`)
};

const fr_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminez le mouvement`)
};

const vi_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn tất chuyển động`)
};

const sw_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamilisha Mwendo`)
};

const th_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำการเคลื่อนไหวให้จบ`)
};

const bs_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Završi pokret`)
};

const ja_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動きを仕上げる`)
};

const ko_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동작을 끝까지 마무리하기`)
};

const pt_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete o movimento`)
};

const it_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa il movimento`)
};

const sv_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avsluta rörelsen`)
};

const nl_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak de beweging af`)
};

const da_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afslut bevægelsen`)
};

const nb_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullfør bevegelsen`)
};

const fi_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vie liike loppuun`)
};

const pl_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokończ ruch`)
};

const ru_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завершите движение`)
};

const tr_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hareketi tamamlayın`)
};

const hi_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गति पूरी करें`)
};

const id_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuntaskan Gerakan`)
};

const ms_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengkapkan Gerakan`)
};

const cs_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokončete pohyb`)
};

const el_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ολοκληρώστε την κίνηση`)
};

const he_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השלימו את התנועה`)
};

const af_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltooi die beweging`)
};

const hu_method_content_step_04_title = /** @type {(inputs: Method_Content_Step_04_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejezd be a mozgást`)
};

/**
* | output |
* | --- |
* | "Finish the Motion" |
*
* @param {Method_Content_Step_04_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_title = /** @type {((inputs?: Method_Content_Step_04_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_title(inputs)
	if (locale === "de") return de_method_content_step_04_title(inputs)
	if (locale === "zh") return zh_method_content_step_04_title(inputs)
	if (locale === "ar") return ar_method_content_step_04_title(inputs)
	if (locale === "fr") return fr_method_content_step_04_title(inputs)
	if (locale === "vi") return vi_method_content_step_04_title(inputs)
	if (locale === "sw") return sw_method_content_step_04_title(inputs)
	if (locale === "th") return th_method_content_step_04_title(inputs)
	if (locale === "bs") return bs_method_content_step_04_title(inputs)
	if (locale === "ja") return ja_method_content_step_04_title(inputs)
	if (locale === "ko") return ko_method_content_step_04_title(inputs)
	if (locale === "pt") return pt_method_content_step_04_title(inputs)
	if (locale === "it") return it_method_content_step_04_title(inputs)
	if (locale === "sv") return sv_method_content_step_04_title(inputs)
	if (locale === "nl") return nl_method_content_step_04_title(inputs)
	if (locale === "da") return da_method_content_step_04_title(inputs)
	if (locale === "nb") return nb_method_content_step_04_title(inputs)
	if (locale === "fi") return fi_method_content_step_04_title(inputs)
	if (locale === "pl") return pl_method_content_step_04_title(inputs)
	if (locale === "ru") return ru_method_content_step_04_title(inputs)
	if (locale === "tr") return tr_method_content_step_04_title(inputs)
	if (locale === "hi") return hi_method_content_step_04_title(inputs)
	if (locale === "id") return id_method_content_step_04_title(inputs)
	if (locale === "ms") return ms_method_content_step_04_title(inputs)
	if (locale === "cs") return cs_method_content_step_04_title(inputs)
	if (locale === "el") return el_method_content_step_04_title(inputs)
	if (locale === "he") return he_method_content_step_04_title(inputs)
	if (locale === "af") return af_method_content_step_04_title(inputs)
	if (locale === "hu") return hu_method_content_step_04_title(inputs)
	return en_method_content_step_04_title(inputs)
});